export default __webpack_public_path__ + "static/media/faz_4.ba5b08ca.png";